import { faFileSlash } from '@fortawesome/pro-light-svg-icons'

import { DashboardModule, Link } from '@domain-group/suit-theme'

import useApiLogs from '@hooks/useApiLogs'
import FailedApiLogsTable from './FailedApiLogsTable'

export const icon = faFileSlash

export const configOptions = () => {}

interface FailedApiLogsProps {
  customOptions: {
    customization?: {
      display_mode?: string,
      title?: string,
    },
  },
  editing: boolean,
}

const FailedApiLogs = (props: FailedApiLogsProps) => {
  const { customOptions, editing } = props

  const apiLogsPayload = useApiLogs({
    filters: {
      limit: 10,
    },
    performHttpRequests: true,
    requestOptions: {
      include_api_actioned_by_user: true,
      success: false,
    },
    skipLoadedForKeysCheck: true,
  })

  const {
    filteredApiLogs,
    hasFilteredApiLogs,
    loading,
  } = apiLogsPayload

  const { customization } = customOptions
  const { title } = customization || {}

  if (!loading && !hasFilteredApiLogs) return null

  return (
    <DashboardModule
      boxProps={{ marginBottom: 0 }}
      contentBoxProps={{ flexDirection: 'column' }}
      editing={editing}
      headerRight={(
        <Link
          href="#/systemManager/apiLogs"
          textProps={{ fontSize: 'xsmall' }}
        >
          View All Logs
        </Link>
      )}
      loading={loading}
      title={title || 'Failed API Calls'}
    >
      <DashboardModule.ScrollableSection>
        <FailedApiLogsTable failedApiLogs={filteredApiLogs} />
      </DashboardModule.ScrollableSection>
    </DashboardModule>
  )
}

export default FailedApiLogs
